export const host = "https://www.zaping.io:8445";
export const loginRoute = `${host}/login`;
export const initChatRoute = `${host}/init-chat`;
export const updateAutoResponse = `${host}/autoresponse`;
export const getMessageRoute = `${host}/message-get`;
export const sendMessageRoute = `${host}/message-send`;
//export const registerRoute = `${host}/api/auth/register`;
//export const logoutRoute = `${host}/api/auth/logout`;
//export const setAvatarRoute = `${host}/api/auth/setavatar`;
